<template>
    <div class="card-container">
        <common-top-form :model="formModel" buttonName="导出" @openAddDialog="exportInfo" :submitService="submitService"
                         :submitData="submitData" @success="onSuccess" buttonType="warning" :showDownloadPower="true"
                         showDownloadPowerType="purple" downloadPowerText="合计" downloadPower="/statistics/tatAssets" @down="down">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <el-form-item label="订单号">
                <el-input v-model="formModel.orderId" maxlength="50" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="业务类型">
                <el-select v-model="formModel.busiType" filterable>
                    <el-option
                        v-for="item in busiTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易类型">
                <el-select v-model="formModel.tranType" filterable>
                    <el-option
                        v-for="item in tranTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="账户类型">
                <el-select v-model="formModel.acctType">
                    <el-option
                        v-for="item in acctTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作类型">
                <el-select v-model="formModel.optType">
                    <el-option
                        v-for="item in optTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="变更日期">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatSimpleId" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="busiType" label="业务类型" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="odrId" label="订单号" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tranType" label="交易类型" min-width="100" :formatter="formatTranTypee"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="acctType" label="账户类型" min-width="100" :formatter="formatAcctTypee"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="optType" label="操作类型" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p :class="[{'text-green':scope.row.optType == 1},{'text-red':scope.row.optType == 2}]">
                        {{scope.row.optType == 1 ? '+' : '-'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="tranAmt" label="变动金额（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.tranAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="balAmt" label="变动后余额（元）" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.balAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="变动时间" min-width="160"></el-table-column>
        </common-table>
        <show-info-dialog title="合计" :show="true" ref="showInfoDialog" dialogWidth="400px" class="showInfoDialog">
            <div>
                <p>变动金额：{{toDoubleThousands(dialogObj.tranAmt * 100 / 10000)}}元</p>
            </div>
        </show-info-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import ShowInfoDialog from '../../dialog/ShowInfoDialog'

    import FinanceService from 'service/FinanceService'
    import OrganService from 'service/OrganService'
    import TimeRange from 'service/constant/TimeRange'
    import StatisticsService from 'service/StatisticsService'

    import AcctTypes from 'service/constant/AcctTypes'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "receivedetailnew",
        components: {
            CommonTopForm, CommonTable, SelectOrgans, ShowInfoDialog
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    tranType: '',
                    optType: '',
                    busiType: '',
                    acctType: '',
                    orderId: '',
                    time: [],
                },
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                busiTypes: [],
                tableData: [],
                page: {},
                params: {},
                optTypes: [{
                    value: '',
                    label: '全部'
                }, {
                    value: '1',
                    label: '收入（+）'
                }, {
                    value: '2',
                    label: '支出（-）'
                },],
                tranTypes: [],
                acctTypes: AcctTypes,
                submitService: FinanceService.getTatAccDtlNew,
                isPage: false,
                dialogObj:{}
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.page = this.$refs.commonTable.page;
            // this.getList();
            this.getTypeNames('交易类型', (res) => {
                this.tranTypes = [{
                    dictKey: '',
                    dictValue: '全部'
                }, ...res];
            });
            this.getTypeNames('业务类型', (res) => {
                this.busiTypes = [{
                    dictKey: '',
                    dictValue: '全部'
                }, ...res]
            });
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    userId: this.userId,
                    orderNo: this.formModel.orderId.trim(),
                    tatSimpleId: this.formModel.tatSimpleId,
                    tranType: this.formModel.tranType,
                    acctType: this.formModel.acctType,
                    busiType: this.formModel.busiType,
                    optType: this.formModel.optType,
                    startDate: this.formModel.time[0],
                    endDate: this.formModel.time[1],
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length == 0) {
                    delete this.params.startDate;
                    delete this.params.endDate;
                }

                return this.params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods: {
            down() {
                this.doLoad(FinanceService.sumTatAccDtlNew,this.submitData,res => {
                    this.doCheck(res,res =>{
                        const result = res.contents;
                        this.dialogObj = result;
                        this.$nextTick(()=>{
                            this.$refs.showInfoDialog.open();
                        })
                    });
                },'信息获取失败')
            },
            formatTranTypee(row, column, cellValue) {
                let value = '';
                this.tranTypes.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : '--';
            },
            formatAcctTypee(row, column, cellValue) {
                let value = '';
                this.acctTypes.forEach(item => {
                    if (item.value == cellValue) {
                        value = item.label;
                    }
                });
                return value ? value : '--';
            },
            exportInfo() {
                this.limitExport(this.page.total) ? StatisticsService.exportExcel(this.submitData, 'tatAcctDtlExport', '8889', '/fin/', true) : '';
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.pageSize = result.size;
                        this.page.total = result.total;

                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                    console.log('result', this.tableData)
                });
            },
        }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/ReceiveDetailNew.vue